/**
 * Satellite control button.
 *
 * Implements IControl:
 * https://docs.mapbox.com/mapbox-gl-js/api/markers/#icontrol
 */
import MapService from "../common/MapService";
import type { IControl, Map } from 'mapbox-gl';

class ShareControl implements IControl {
    _map: Map | undefined;
    /** Clase de estilo activa. Se asigna en onAdd. */
    mapStyle: string | undefined;
    _container = document.createElement('div');
    _button = document.createElement('button');
    CLASS_ACTIVE = 'active';
    CLASS_INACTIVE = 'inactive';
    CLASS_VISIBLE = 'visible';
    CLASS_BUTTON_SHARE = 'button_share';
    CLASS_BUTTON_CONTROL = 'mapboxgl-ctrl';
    visible = false;

    handleButtonClick(): void {
        MapService.mapEventShareControlClick();
    }

    onAdd(map: Map): HTMLElement {
        this._map = map;
        this._container.className = this.CLASS_BUTTON_CONTROL + ' mapboxgl-ctrl-group ' + this.CLASS_BUTTON_SHARE;
        this.mapStyle = this.CLASS_ACTIVE;
        this._button.addEventListener('click', this.handleButtonClick.bind(this));
        this._container.appendChild(this._button);
        return this._container;
    }

    onRemove(): void {
        this._container.parentNode!.removeChild(this._container);
        this._map = undefined;
    }

    setVisible(_visible: boolean): void {
        this._container.classList.toggle(this.CLASS_VISIBLE, _visible);
        this.visible = _visible;
    }
}

export default ShareControl;
